<template>
  <el-container>
    <!-- Order summary -->
    <el-aside v-if="isInBooking">
      <AsideOrderSummary />
    </el-aside>

    <!-- Main content -->
    <el-main style="padding-top: 0px; padding-bottom: 0px">
      <router-view v-slot="{ Component, route }">
        <transition name="el-fade-in-linear" mode="out-in">
          <div style="height: 100%" :key="route.name">
            <component :is="Component"></component>
          </div>
        </transition>
      </router-view>
    </el-main>
  </el-container>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";

// modules
import AuthModule from "@/store/modules/auth";

// components
import { AsideOrderSummary } from "@/components/index";

export default defineComponent({
  name: "AppMain",
  components: {
    AsideOrderSummary,
  },
  setup() {
    const isInBooking = computed(() => {
      return AuthModule.isInBooking;
    });

    return { isInBooking };
  },
});
</script>

<style lang="scss" scoped>
.el-aside {
  height: 100%;
}
</style>
